import { render } from "./NotificationItem.vue?vue&type=template&id=538e021c"
import script from "./NotificationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/NotificationItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "538e021c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('538e021c', __exports__)) {
    api.reload('538e021c', __exports__)
  }
  
  module.hot.accept("./NotificationItem.vue?vue&type=template&id=538e021c", () => {
    api.rerender('538e021c', render)
  })

}


export default __exports__